import { useApolloClient } from "@apollo/client";
import React, { createContext, useContext } from "react";
import { CREATE_ORGANIZATION } from "../operations/Auth.mutations";

let operationsAllowed: any = {};
const AuthRepositoryContext = createContext(operationsAllowed);

export const AuthRepositoryProvider = (props: any) => {
  const client = useApolloClient();

  const login = (credentials: any) => {
    // return client.mutate();
  };

  const logout = () => {
    // return client.mutate();
  };

  // const getRates = () => {
  //  return client.query({
  //     query: GET_RATES
  //   });
  // }

  const createOrganization = (organization: any) => {

    let organizationDTO: any = {};
    organizationDTO["firstName"]=organization.firstName;
    organizationDTO["lastName"] = organization.lastName;
    organizationDTO["name"] = organization.companyName;
    organizationDTO["country"] = 2;
    organizationDTO["emailAddress"] = organization.workEmailId;
    organizationDTO["noOfEmployees"] = organization.numberOfEmployees;

    return client.mutate({mutation: CREATE_ORGANIZATION, variables: {organization: organizationDTO}});
  }

  operationsAllowed = {
    login,
    logout,
    createOrganization
  };

  return (
    <AuthRepositoryContext.Provider value={operationsAllowed}>
        {props.children}
    </AuthRepositoryContext.Provider>
  );
};

export const useAuthRepository = () => {
  return useContext(AuthRepositoryContext);
}
